import { t } from 'ttag';

// The widget content types, matching the API's `contentEntityType` values.
export const WIDGET_ENTITY_TYPE = {
  PEOPLE: 'people',
  SESSIONS: 'sessions',
  COMPANIES: 'companies',
};

// The registration-form widget has no content-widgets record: the list API never
// returns it, it can't be created or deleted, and its details route resolves by
// this sentinel id instead of a UUID. Kept out of WIDGET_ENTITY_TYPE so it stays
// out of the Add Widget menu and the API-backed type filter.
export const REG_FORM_WIDGET_ID = 'reg-form';
export const REG_FORM_WIDGET_TYPE = 'registration';

// Single source of truth for the user-facing label of each widget type. Kept as
// a function so the ttag strings resolve against the active locale at call time.
export const getWidgetTypeLabel = type =>
  ({
    [WIDGET_ENTITY_TYPE.PEOPLE]: t`People`,
    [WIDGET_ENTITY_TYPE.SESSIONS]: t`Sessions`,
    [WIDGET_ENTITY_TYPE.COMPANIES]: t`Companies`,
    [REG_FORM_WIDGET_TYPE]: t`Registration`,
  })[type];

// Client-side stand-in for the row the list API can't provide.
export const getRegFormWidgetRow = () => ({
  id: REG_FORM_WIDGET_ID,
  name: t`Registration Form`,
  contentEntityType: REG_FORM_WIDGET_TYPE,
});

// The layouts a widget can render in (FE-owned; Sessions uses List only).
const WIDGET_LAYOUT = {
  LIST: 'list',
  GRID: 'grid',
  CAROUSEL: 'carousel',
};

// User-facing Layout picker options; a function so the labels resolve against the active locale at call time.
export const getLayoutOptions = () => [
  { label: t`List`, value: WIDGET_LAYOUT.LIST },
  { label: t`Grid`, value: WIDGET_LAYOUT.GRID },
  { label: t`Carousel`, value: WIDGET_LAYOUT.CAROUSEL },
];

// FE-owned default styleConfig (opaque to the backend); seeds new widgets and fills the Layout & Design fields.
export const DEFAULT_STYLE_CONFIG = {
  layout: WIDGET_LAYOUT.LIST,
  colors: {
    accent: '#1677FF',
    text: '#222222',
    widgetBackground: '#FAFAFA',
    cardBackground: '#FFFFFF',
  },
  image: { size: 200, cornerRadius: 0 },
  concurrentSessions: false,
};

// Minimal valid create config: the API requires appliedEntityType and a non-empty
// viewFields; styleConfig seeds the FE-owned defaults.
export const DEFAULT_WIDGET_CONFIG = {
  [WIDGET_ENTITY_TYPE.PEOPLE]: {
    queryConfig: { appliedEntityType: 'all', sort: 'last_name' },
    fieldConfig: { viewFields: ['first_name', 'last_name'] },
    styleConfig: DEFAULT_STYLE_CONFIG,
  },
  [WIDGET_ENTITY_TYPE.SESSIONS]: {
    queryConfig: { appliedEntityType: 'all', sort: 'start_datetime' },
    fieldConfig: { viewFields: ['name'] },
    styleConfig: DEFAULT_STYLE_CONFIG,
  },
  [WIDGET_ENTITY_TYPE.COMPANIES]: {
    queryConfig: { appliedEntityType: 'all', sort: 'name' },
    fieldConfig: { viewFields: ['name'] },
    styleConfig: DEFAULT_STYLE_CONFIG,
  },
};
